import { singularityFieldConfig } from "./singularityFieldConfig";

export type GravitationalFieldProfileConfig = {
  innerRadius: number;
  outerRadius: number;
  coreExponent: number;
  maxRadialShift: number;
  maxNormalShift: number;
};

export type GravitationalDistortionConfig = {
  profiles: {
    anchor: GravitationalFieldProfileConfig;
    orbital: GravitationalFieldProfileConfig;
    connector: GravitationalFieldProfileConfig;
  };
};

export const gravitationalDistortionConfig: GravitationalDistortionConfig = {
  profiles: {
    anchor: {
      innerRadius: 8.2,
      outerRadius: singularityFieldConfig.semanticInfluenceRadius,
      coreExponent: 1.35,
      maxRadialShift: 3.35,
      maxNormalShift: 1.08,
    },
    orbital: {
      innerRadius: 8.2,
      outerRadius: singularityFieldConfig.semanticInfluenceRadius - 2,
      coreExponent: 1.28,
      maxRadialShift: 3.05,
      maxNormalShift: 0.94,
    },
    connector: {
      innerRadius: 7.8,
      outerRadius: singularityFieldConfig.semanticInfluenceRadius + 4,
      coreExponent: 1.22,
      maxRadialShift: 3.9,
      maxNormalShift: 1.22,
    },
  },
};
